import { FC, ReactNode } from "react"
import { Link } from "react-router-dom"

import { Flex, FlexItem } from "components/Flex"
import FlexibleContent from "components/FlexibleContent/FlexibleContent"
import Routes from "routes/index"
import { CustomerTab } from "routes/CustomerRoute"
import CustomerNumberBlockedIcon from "./CustomerNumberBlockedIcon"

interface ICustomerNumber {
    customerNumber?: string
    blocked?: boolean
    blockedTooltipText?: ReactNode
    asLink?: boolean
}

/**
 * Renders a customer number, optionally as a link to the customer page (`asLink`)
 * and with a blocked indicator when `blocked`. The link is shown for both blocked
 * and active customers.
 */
const CustomerNumber: FC<ICustomerNumber> = ({
    customerNumber,
    blocked,
    blockedTooltipText,
    asLink,
}) => {
    const numberContent = asLink && customerNumber
        ? <Link
            className="link color-brand-blue"
            to={Routes.customer.getPath({ customerNumber, tab: CustomerTab.requests })}>
            <FlexibleContent text={customerNumber} />
        </Link>
        : <FlexibleContent text={customerNumber} />

    if (!blocked) {
        return <Flex inline>
            {numberContent}
        </Flex>
    }

    return (
        <Flex
            inline
            alignItems="center"
            gap="0.6rem"
            className="color-red-500">
            {!!customerNumber &&
                numberContent
            }
            <FlexItem shrink={0}>
                <CustomerNumberBlockedIcon tooltipText={blockedTooltipText} />
            </FlexItem>
        </Flex>
    )
}

export default CustomerNumber
